import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {Store} from "@ngrx/store";
import {
  Config,
  getConfig, getLookups,
  initialConfigState,
  initialLookupsState,
  Lookups
} from "../../../redux";
import {IBusinessUnit} from "../../models";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BusinessUnitService} from "../../services";
import { LookupService } from 'src/app/services';

@Component({
  selector: 'app-business-unit-modal',
  templateUrl: './business-unit-modal.component.html',
  styleUrls: ['./business-unit-modal.component.scss']
})
export class BusinessUnitModalComponent {

  userForm = new FormGroup({
    id: new FormControl(),
    slug: new FormControl('', [Validators.required, Validators.minLength(4), Validators.max(12)]),
    displayName: new FormControl('', []),
    internalName: new FormControl('', []),
    businessUnitType: new FormControl("", [Validators.required]),
    subType: new FormControl("", [Validators.required]),
    domicile: new FormControl('', [Validators.required]),
    intakeDescription: new FormControl(''),
  });

  constructor(public dialogRef: MatDialogRef<BusinessUnitModalComponent>,
              // @Inject(MAT_DIALOG_DATA) public data: any,
              // private businessUnitService: BusinessUnitService,
              public lookupService: LookupService,
              // private toastr: ToastrService, 
              // private store: Store
  ) {
  }

}
